module.exports = __webpack_public_path__ + "PERUVIANhome-3.ec025ece.png";